import React from "react"
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete'; //https://material-ui.com/components/autocomplete/
import COMPANYUNIVERSE from "../data/companies.json"
import COMPANYUNIVERSEOPTIONSONLY from "../data/companies_options.json"
import {logEvent} from "../analytics";

export default class TickerDropDown extends React.Component 
  {
    state = {
      selectedCompany: this.getDefault()
    }
    selectionChanged = (event,newValue) =>  {
        this.setState({selectedCompany:newValue})
        const newTicker=(newValue == null) ? "" : newValue.ticker
        this.props.onSelectedTickerChanged(newTicker); //pass it up to container
        logEvent("tickerChanged",{ticker:newTicker});
    }
    getDefault() {
      return this.CompanyList().find((company)=>company.ticker===this.props.defaultTicker)
    }
    //indicates whether we should be displaying only companies which have option chains
    //if the OptionsOnly flag isn't set, we'll default to false
    optionsOnlyMode() {
      if (Object.keys(this.props).includes('OptionsOnly')) {
        return (this.props.OptionsOnly === true);
      }
      return false;
    }
    CompanyList() {
      if (this.optionsOnlyMode()===true) {
        return COMPANYUNIVERSEOPTIONSONLY;
      }
      return COMPANYUNIVERSE;
    }
   
    render() {
        return (
            <Autocomplete
              id="tickerSelect"
              value={this.state.selectedCompany}
              options={this.CompanyList()}
              getOptionLabel={(option) => `${option.ticker} - ${option.name}`}
              style={{ width: 300 }}
              onChange={this.selectionChanged}
              renderInput={(params) => <TextField {...params} label="Ticker" variant="outlined" helperText={this.props.helperText}/>}
            />
        );
    }
  

  }